import { z as zod, type ZodType } from 'zod';

import { createBaseDatastreamDtoSchema } from './create-base-datastream-dto-schema';

/**
 * Creates a Zod schema for a base datastream DTO with optional `name` and `niceName` string fields.
 *
 * @template TId - The Zod type for the ID field, defaults to `zod.ZodNumber`.
 * @param idSchema - Optional Zod schema for the ID field. If not provided, defaults to a number schema.
 * @returns A Zod schema that extends the base datastream DTO schema with optional `name` and `niceName` fields.
 */
export const createBaseDatastreamNamedDtoSchema = <TId extends ZodType = zod.ZodNumber>(idSchema?: TId) => {
  const baseSchema = createBaseDatastreamDtoSchema(idSchema);

  return baseSchema.extend({
    name: zod.string().optional(),
    niceName: zod.string().optional(),
  });
};
